/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_TInputs */

const en_tut_inbox_t = /** @type {(inputs: Tut_Inbox_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox: everything that needs you, in one place`)
};

const id_tut_inbox_t = /** @type {(inputs: Tut_Inbox_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox: satu tempat semua yang butuh Anda`)
};

/**
* | output |
* | --- |
* | "Inbox: everything that needs you, in one place" |
*
* @param {Tut_Inbox_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_t = /** @type {((inputs?: Tut_Inbox_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_t(inputs)
	return en_tut_inbox_t(inputs)
});